import { Action, combineReducers, createStore, applyMiddleware, compose } from "@reduxjs/toolkit";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { TAction } from "./VisibilityActions";
import { VisibilityReducer } from "./VisibilityReducer";

const visibilityRootReducer = combineReducers({
	Visibility: VisibilityReducer,
});

export type VisibilityRootState = ReturnType<typeof visibilityRootReducer>;
export interface DispatchAction<T> extends Action {
	payload: T;
}

const middleware = thunk as ThunkMiddleware<VisibilityRootState, DispatchAction<TAction>>;

export const visibilityStore = createStore(visibilityRootReducer, compose(applyMiddleware(middleware)));
